// removed by extract-text-webpack-plugin
module.exports = {"link":"Button__link__1rmae","button":"Button__button__2HVKL","filled":"Button__filled__1_tDJ","common":"Button__common__MWEHy","icon":"Button__icon__2QxBQ","labelWrapper":"Button__labelWrapper__2ejGl","label":"Button__label__2aCVj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/controls/Button.scss
// module id = 637
// module chunks = 0